import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import UserPage from './pages/user/UserPage';
import LoginPage from './pages/admin/LoginPage';
import AdminLayout from './pages/admin/AdminLayout';
import DashboardPage from './pages/admin/DashboardPage';
import ProjectsManagePage from './pages/admin/ProjectsManagePage';
import ECommerceDemo from './pages/demos/ECommerceDemo';
import TodoDemo from './pages/demos/TodoDemo';
import ChatbotDemo from './pages/demos/ChatbotDemo';
import ContractDemo from './pages/demos/ContractDemo';
import WalletDemo from './pages/demos/WalletDemo';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-dark flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* User Routes */}
          <Route path="/" element={<UserPage />} />

          {/* Demo Routes */}
          <Route path="/demos/ecommerce" element={<ECommerceDemo />} />
          <Route path="/demos/todo" element={<TodoDemo />} />
          <Route path="/demos/chatbot" element={<ChatbotDemo />} />
          <Route path="/demos/contract" element={<ContractDemo />} />
          <Route path="/demos/wallet" element={<WalletDemo />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<LoginPage />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="projects" element={<ProjectsManagePage />} />
            <Route path="posts" element={<div className="text-white">Posts Management (Coming Soon)</div>} />
            <Route path="contacts" element={<div className="text-white">Contacts Management (Coming Soon)</div>} />
            <Route path="stats" element={<div className="text-white">Stats Management (Coming Soon)</div>} />
            <Route path="settings" element={<div className="text-white">Settings (Coming Soon)</div>} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
